import React from "react";
import PropTypes from "prop-types";

import { Graphics } from "./components/Graphics";

import "./style.scss";

export class Trash extends React.Component {
  componentWillMount() {
    this.props.createTrash({
      props: this.props.defaultProps,
    });
  }

  toggleOpen = () => {
    if(this.props.type === "Biohazard"){
      this.props.trashOpen({
        id: this.props.id,
        open: !this.props.open,
      });
    }
  };

  render() {
    return (
      <ul>
        <li
          id={"Trash_"+this.props.id}
          aria-label="Trash can"
          tabIndex={0}
          onClick={this.toggleOpen}
          onKeyDown={(e) => {
            if (e.keyCode === 13 || e.keyCode === 32) this.toggleOpen(e);
          }}
          className={"Trash dropTarget "+((this.props.type === "Biohazard")?(!this.props.open)?"closed":"open":null)}
        >
          <p aria-hidden="true" className="label">
            {this.props.type === "Biohazard" ? "Biohazardous waste" : "Trash"}
          </p>
          <Graphics id={this.props.id} />
        </li>
      </ul>
    );
  }
}

Trash.propTypes = {
  createTrash: PropTypes.func,
};

Trash.defaultProps = {};
